import React from 'react'
import { DialogContentText, DialogContentTextProps } from '@material-ui/core'
import { darkBlue } from '../../styles/material-ui-theme-v2'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'
import { useYumDialogContext } from '../YumDialog/YumDialog'

interface IYumDialogContentText extends DialogContentTextProps {}

const YumDialogContentText = withStyles((theme: Theme) =>
  createStyles({
    root: { color: darkBlue, margin: 0 },
  }),
)(({ children, classes, id, ...props }: IYumDialogContentText) => {
  // Adopt the id from YumDialog so the dialog's aria-describedby resolves to this
  // message and screen readers announce it when the dialog opens (WCAG 4.1.2).
  const dialogContext = useYumDialogContext()
  const resolvedId = id ?? dialogContext?.descriptionId
  return (
    <DialogContentText classes={classes} id={resolvedId} {...props}>
      {children}
    </DialogContentText>
  )
})

export default YumDialogContentText
